import React from 'react';
import _ from "lodash";
import * as echarts from 'echarts~5';
import style from './index.module.scss';
import { DEFAULT_OPTION } from './utils';

export default class Comp extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            title: "",
            yAxisLeft: {
                "upper_limit": null,
                "lower_limit": null,
                "unit": null
            },
            yAxisRight: {
                "upper_limit": null,
                "lower_limit": null,
                "unit": null
            },
            metaList: [],
        };
    }

    componentDidMount() {
        this.updateChart(this.props.config, null)
    }

    componentWillReceiveProps(nextProps) {
        this.updateChart(nextProps.config, null);
    }

    fetchData = () => {

    }

    updateChart = (config, data) => {
        if (!this.chartNode) {
            return;
        }

        if (!config) {
            return;
        };

        let option = _.cloneDeep(DEFAULT_OPTION);
        // let yAxisLeft = false;
        let yAxisRight = false;
        option.series = config.meta_list.map(item => {
            let _s = {
                data: [],
                type: item['type'],
                itemStyle: {
                    color: item['color']
                },
                yAxisIndex: (item['y_axis'] === 'right' ? 1 : 0),
                symbol: 'none'
            }
            if (item['y_axis'] === 'left') {
                // yAxisLeft = true;
            } else if (item['y_axis'] === 'right') {
                yAxisRight = true;
            }
            return _s;
        });

        if (yAxisRight === false) {
            option.yAxis.pop();
        }
        let instance = echarts.getInstanceByDom(this.chartNode);
        if (!instance) {
            instance = echarts.init(this.chartNode);
        } else {
            instance.clear();
        };

        instance.setOption(option);
    }

    render() {
        const { config } = this.props;

        return (
            <div className={style["wrapper"]}>
                <div className="header">
                    <div className="colored_bar"></div>
                    <div className="title">{config?.title ?? "--"}</div>
                </div>
                <div className="content">
                    <div ref={(refNode) => this.chartNode = refNode} style={{ height: '100%' }} />
                </div>
            </div>
        );
    }
}
